import React from 'react'
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { changeAgentTab } from "actions/agentTabAction";
import { AgentTabView } from 'constants/ChatViewConstants';
import { CallBackIcon, ChatIcon, RaiseQueryIcon } from 'images/Icons';
import "./AgentLeftSection.scss"
import AgentSideNavBar from 'components/AgentSideNavBar/AgentSideNavBar';
function AgentLeftSection(props) {
    const { agentTab, agentBgMsgCount } = props;
    const highlightedClass = (tab) =>
        agentTab.section === tab ? "highlighted" : "";
    const Tabs = [
        {
            value: AgentTabView.AGENT_CHAT,
            icon: <ChatIcon />,
            label: "AGENT CHAT",
            active: agentTab.section === AgentTabView.AGENT_CHAT,
            className: highlightedClass(AgentTabView.AGENT_CHAT),
            count: agentBgMsgCount.count
        },
        {
            value: AgentTabView.RAISE_QUERY,
            icon: <RaiseQueryIcon />,
            label: "RAISE QUERY",
            active: agentTab.section === AgentTabView.RAISE_QUERY,
            className: highlightedClass(AgentTabView.RAISE_QUERY),
        },
        {
            value: AgentTabView.REQUEST_CALLBACK,
            icon: <CallBackIcon />,
            label: "REQUEST CALLBACK",
            active: agentTab.section === AgentTabView.REQUEST_CALLBACK,
            className: highlightedClass(AgentTabView.REQUEST_CALLBACK),
        },
    ];


    const onTabChange = (item) => {
        props.changeAgentTab(item.value);
    }

    return (
        <div className='agent-side-nav'>
            <AgentSideNavBar navItems={Tabs} onTabChange={onTabChange} />
        </div>
    )
}
const mapStateToProps = (state) => ({
    agentTab: state.agentTab,
    agentBgMsgCount: state.agentBgMsgCount
});

const mapDispatchToProps = {
    changeAgentTab,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AgentLeftSection);
